import { useHistory } from 'react-router-dom';

import {
  Link,
  LinkProps,
} from '@ui/Link';

export type LocalizedLinkProps = LinkProps & { href: string };

export const LocalizedLink: React.FC<LocalizedLinkProps> = ({
  href,
  ...props
}) => {
  const history = useHistory();
  const localizedHref = history.createHref({ pathname: href });

  return <Link {...props} href={localizedHref} />;
};
